import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { getPage, setSelectedCityId } from 'src/store/app.state.store'
import { setAppointmentSalon } from 'src/store/appointment.store'
import { getSalons } from 'src/store/data.store'
import { Modal } from 'components/Utility/Modal/Modal'
import { Salons } from 'components/PageElements/Salons/Salons'
import { ServicesPicker } from '../ServicesPicker/ServicesPicker'
import { AppointmentForm } from './AppointmentForm'

type AppointmentFormControllerProps = {
  onSubmit: () => void,
}

/** The booking form and its salon and services pickers, one modal at a time */
export const AppointmentFormController: React.FC<AppointmentFormControllerProps> = ({ onSubmit }) => {
  const [stage, setStage] = useState<'form' | 'salon' | 'services'>('form')
  const [servicesClientIndex, setServicesClientIndex] = useState(0)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const salons = useSelector(getSalons)
  const page = useSelector(getPage)

  const setFormStage = useCallback(() => setStage('form'), [])

  const handleSelectSalon = useCallback((salonId: number) => {
    const salon = salons.find(({ id }) => id === salonId)
    if (!salon) {
      return
    }
    dispatch(setSelectedCityId(salon.cityId))
    setFormStage()
  }, [setFormStage, salons, dispatch])

  // Booking from a salon page starts with that salon
  useEffect(() => {
    const salonId = page?.template === 'salon-page' ? page.templateVars?.pageVars?.salon?.id : undefined
    if (salonId) {
      dispatch(setAppointmentSalon(salonId))
      handleSelectSalon(salonId)
    }
  }, [page, handleSelectSalon, dispatch])

  if (stage === 'salon') {
    return (
      <Modal isOpen title={'Выберите салон'} back={setFormStage} onClose={setFormStage}>
        <Salons onSelectSalon={handleSelectSalon} lazy={false} listPageSize={4} />
      </Modal>
    )
  }

  if (stage === 'services') {
    return (
      <Modal
        isOpen
        title={`Выберите услуги для гостя ${servicesClientIndex + 1}`}
        back={setFormStage}
        onClose={setFormStage}
      >
        <ServicesPicker clientIndex={servicesClientIndex} onSubmit={setFormStage} />
      </Modal>
    )
  }

  return (
    <Modal isOpen title={'Записаться'} onClose={() => navigate('#', { replace: true })}>
      <AppointmentForm
        onChooseServices={(clientIndex) => {
          setServicesClientIndex(clientIndex)
          setStage('services')
        }}
        onChooseSalon={() => setStage('salon')}
        onSubmit={onSubmit}
      />
    </Modal>
  )
}
